import React from 'react';
import { isRBFeature } from '@/lib/featureFlags';
import { useAuthenticated } from '@gettactic/hooks';
import { ReserveFormWeekDaysSelect } from '@/components/reserve/Reserve/controls/ReserveFormWeekDaysSelect';

export const ReserveFormWeekDays: React.FC = () => {
  const {
    userContext: { authenticatedUser, currentOffice }
  } = useAuthenticated();

  const isRedBullFlag = !!isRBFeature(authenticatedUser);
  if (!isRedBullFlag) return null;

  return (
    <div className="text-left">
      <ReserveFormWeekDaysSelect />
    </div>
  );
};
